import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon, SvgIconType, isFieldVisible, Button, } from '@integration-app/react';
import classes from './AddLevelButton.module.css';
import { NestedLevel } from './NestedLevel';
import useEventStopPropagation from '../../../hooks/useEventStopPropagation';
export function AddLevelButton({ children, field, onAdd, }) {
    var _a, _b, _c;
    if (((_a = field === null || field === void 0 ? void 0 : field.level) !== null && _a !== void 0 ? _a : -1) < 0) {
        return null;
    }
    const handleOnAdd = useEventStopPropagation(onAdd);
    if (((_b = field === null || field === void 0 ? void 0 : field.schema) === null || _b === void 0 ? void 0 : _b.type) === 'object' && !isFieldVisible(field)) {
        return _jsx(RootAddButton, { onClick: handleOnAdd, children: "Add Field" });
    }
    if (((_c = field === null || field === void 0 ? void 0 : field.schema) === null || _c === void 0 ? void 0 : _c.type) !== 'object' && field.level === 0) {
        return _jsx(RootAddButton, { onClick: handleOnAdd, children: "Add Field" });
    }
    const buttonText = children || (field === null || field === void 0 ? void 0 : field.name) ? `Add field to ${field === null || field === void 0 ? void 0 : field.name}` : 'Add Field';
    return (_jsx(NestedLevel, { level: field === null || field === void 0 ? void 0 : field.level, children: _jsx("div", { className: classes.addFieldButtonInnerLevel, children: _jsx(AddButton, { onClick: handleOnAdd, children: buttonText }) }) }));
}
function RootAddButton({ children, onClick }) {
    return (_jsx("div", { className: classes.addFieldButtonRootLevel, children: _jsx(AddButton, { onClick: onClick, children: children }) }));
}
function AddButton({ children, onClick }) {
    return (_jsxs(Button, { variant: 'text', onClick: onClick, children: [_jsx(SvgIcon, { type: SvgIconType.Add }), children] }));
}
//# sourceMappingURL=AddLevelButton.js.map